// angular
import { CommonModule } from '@angular/common';
import { Component, effect, inject, input, output } from '@angular/core';
import { UserService } from '@shared/services/user.service';

export type buttonVariants =
  | 'primary'
  | 'secondary'
  | 'info'
  | 'white'
  | 'normal'
  | 'primary-outlined'
  | 'secondary-outlined';
export type buttonSizes = 'medium' | 'large';
export type buttonColors = 'white' | 'default' | 'danger' | 'success' | 'info';

@Component({
  selector: 'pwj-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  private _isDestroyed = false;

  // inputs
  variant = input<buttonVariants>('normal');
  color = input<buttonColors>('default');
  size = input<buttonSizes>('medium');
  icon = input<string | null>(null);
  iconReversePosition = input<boolean | null>(null);
  noContentButton = input<boolean>(false);

  uppercase = input<boolean>();
  disabled = input<boolean>();
  rotateIconInRtl = input<boolean>();
  withBadge = input<boolean>();
  fullRounded = input<boolean>();
  wFull = input<boolean>();
  buttonClasses = input<string>();
  textCenter = input<boolean>();
  iconClasses = input<string>();
  type = input<string>('button');

  clicked = output<MouseEvent>();

  private readonly _userService = inject(UserService);

  isUserLoggedIn = false;

  constructor() {
    // checked user logged-in or no
    effect(() => {
      this.isUserLoggedIn =
        (this._userService.userSignal()?.roles?.length || 0) > 0 &&
        !!this._userService.userSignal()?.mobile_verified;
    });
  }

  public handleClick(event: MouseEvent) {
    if (!this._isDestroyed) {
      this.clicked.emit(event);
    }
  }

  ngOnDestroy() {
    this._isDestroyed = true;
  }
}
